import React, { useEffect } from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import classnames from 'classnames';
import { AvailabilityBusiness } from '@business/newCreateRequest/stepsItems/availability';
import { Button } from 'oned';
import { AvailabilityType } from '@common/enums/availability';
var NewAvailabilityIndex = inject(AvailabilityBusiness)(observer(function (props) {
    var availabilityStep = props.availabilityStep, availabilityType = props.availabilityType, flexibleType = props.flexibleType, setAvailabilityParams = props.setAvailabilityParams, clearAvailabilityData = props.clearAvailabilityData, currentUser = props.currentUser, getResidentInfo = props.getResidentInfo;
    useEffect(function () {
        if (currentUser.residentId) {
            getResidentInfo(currentUser.residentId);
        }
    }, [currentUser.residentId]);
    var changeAvailabilityType = function (type) {
        switch (type) {
            case AvailabilityType.Flexible:
                if (availabilityType === AvailabilityType.Flexible) {
                    setAvailabilityParams('availabilityType', null);
                }
                else {
                    setAvailabilityParams('availabilityType', AvailabilityType.Flexible);
                }
                clearAvailabilityData();
                setAvailabilityParams('flexibleType', null);
                break;
            case AvailabilityType.Limited:
                if (availabilityType === AvailabilityType.Limited) {
                    setAvailabilityParams('availabilityType', null);
                }
                else {
                    setAvailabilityParams('availabilityType', AvailabilityType.Limited);
                }
                clearAvailabilityData();
                setAvailabilityParams('flexibleType', null);
                break;
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement("h2", null,
            React.createElement("b", { className: 'title' }, "Select your availability")),
        React.createElement("div", { className: 'pt-0 ft-16' }, "Your request will require a specialist. What is your general availability?"),
        React.createElement("div", { className: 'row' },
            React.createElement("div", { className: 'col-md-4 col-xs-12' },
                React.createElement(Button, { type: 'secondary', className: classnames('w-100 my-2 dsm-btn-secondary dsm-btn sc-btn f14', availabilityType === AvailabilityType.Flexible && 'active'), onClick: function () { return changeAvailabilityType(AvailabilityType.Flexible); } }, "My Schedule is Flexible"),
                React.createElement("div", { className: 'pt-1 f14' }, "You are available more often than not. For example, you work from home.")),
            React.createElement("div", { className: 'col-md-4 col-xs-12' },
                React.createElement(Button, { type: 'secondary', className: classnames('w-100 my-2 dsm-btn-secondary dsm-btn sc-btn f14', availabilityType === AvailabilityType.Limited && 'active'), onClick: function () { return changeAvailabilityType(AvailabilityType.Limited); } }, "I Have Limited Availability"),
                React.createElement("div", { className: 'pt-1 f14' }, "You are only able to be home at specific times. i.e. you must take time off work."))));
}));
export default NewAvailabilityIndex;
